import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  const { login, error, loading: isLoading } = useAuth();

  // Use effect to update local error when context error changes
  useEffect(() => {
    if (error) {
      console.log('Login component: Error from context updated:', error);
    }
  }, [error]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted');
    
    if (!username || !password) {
      setLocalError('Please enter both username and password');
      return;
    }
    
    setLocalError('');
    console.log('Attempting login...');
    
    // Use a non-async function to prevent any potential issues with React's synthetic events
    // Capture the event in a variable to persist it
    const event = e;
    
    // Explicitly prevent default again to be extra safe
    event.preventDefault();
    
    login(username, password).then(success => {
      if (success) {
        console.log('Login successful');
        // Reset form on successful login
        setUsername('');
        setPassword('');
      } else {
        console.log('Login failed');
        // Form values are preserved on failure
      }
    }).catch(err => {
      console.error('Login error in component:', err);
      // Make sure we handle any unexpected errors
      setLocalError('An unexpected error occurred. Please try again.');
    });
    
    // Return false to ensure no form submission happens
    return false;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Determine which error message to show (local validation or auth error)
  const displayError = localError || error;

  return (
    <div className="login-container">
      <div className="login-form-container">
        <h1>Watson by MWG</h1>
        <h2>Admin Login</h2>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username or Email</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={isLoading}
              placeholder="Enter your username or email"
              autoComplete="username"
              autoFocus
            />
          </div>
          
          <div className="form-group password-field">
            <label htmlFor="password">Password</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                placeholder="Enter your password"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle-button"
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Hide password" : "Show password"}
                tabIndex="0"
              >
                {showPassword ? "👁️‍🗨️" : "👁️"}
              </button>
            </div>
          </div>
          
          {/* Error message positioned between password field and login button */}
          {displayError && (
            <div className="error-message">
              {displayError}
            </div>
          )}
          
          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
